import axios from 'axios';
import config from 'api/urls-config.json';

export const getCareer = params => {
    return axios.get(`${config.API + config.pages.career}`, { params });
};

// TODO use this for Vacancies list!
export const getVacancies = params => {
    return axios.get(`${config.API + config.vacancies_list}`, { params });
};

export const getVacancy = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.pages.vacancy_slug + slug}`, {
        params: {
            language,
            country,
        },
    });
};
